import { render } from "./GuestLayout.vue?vue&type=template&id=678c78e5"
import script from "./GuestLayout.vue?vue&type=script&lang=js"
export * from "./GuestLayout.vue?vue&type=script&lang=js"
script.render = render

export default script